module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "toc"
    }
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COVER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "Ref_202429a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001#Ref_202429"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202359a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002#Ref_202359"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202362a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003#Ref_202362"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202365a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004#Ref_202365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202368a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005#Ref_202368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202371a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006#Ref_202371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202374a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007#Ref_202374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202377a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008#Ref_202377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202380a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009#Ref_202380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202383a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#Ref_202383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202386a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011#Ref_202386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202389a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012#Ref_202389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202392a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013#Ref_202392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202395a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014#Ref_202395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202399a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#Ref_202399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202402a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016#Ref_202402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202405a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017#Ref_202405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202408a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018#Ref_202408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202411a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#Ref_202411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202414a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#Ref_202414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202417a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021#Ref_202417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202420a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#Ref_202420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202423a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023#Ref_202423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-discover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/discoverpage"
    }
  }, [_vm._v("DISCOVER MORE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202353b"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXTRAS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "Ref_202353a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001#Ref_202353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEET THE AUTHOR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "Ref_202356a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002#Ref_202356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERVIEW")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "Ref_202497a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001#Ref_202497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("TWO CAN PLAY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "Ref_202500a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser002#Ref_202500",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("DEAD RINGER")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202509a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard#Ref_202509"
    }
  }, [_vm._v("BY KATE KESSLER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_202503a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/praise#Ref_202503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAISE FOR "), _c('em', [_vm._v("IT TAKES ONE")])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter001"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0